import { render, staticRenderFns } from "./AddCashCollection.vue?vue&type=template&id=38054129&scoped=true&"
import script from "./AddCashCollection.vue?vue&type=script&lang=js&"
export * from "./AddCashCollection.vue?vue&type=script&lang=js&"
import style0 from "./AddCashCollection.vue?vue&type=style&index=0&id=38054129&prod&scoped=true&lang=css&"
import style1 from "./AddCashCollection.vue?vue&type=style&index=1&id=38054129&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38054129",
  null
  
)

export default component.exports